// extracted by mini-css-extract-plugin
module.exports = {"container":"SeoText__container","article":"SeoText__article","title":"SeoText__title","paragraph":"SeoText__paragraph","column":"SeoText__column"};